import { queryOptions } from '@tanstack/react-query'

import { isResponseStatusCode } from 'utils/api'

import { getMealRatingSummary } from '../service/combinedapi/mealRatingSummary'
import { getMealRatingSummaryFromCDN } from '../service/cdn/mealRatingSummary'
import { isRatingsCDNEnabled } from '../service/cdn/ratingsCDN'

async function getMealRatingSummaryPreferringCDN({
  mealID,
}: {
  mealID: number
}) {
  if (!isRatingsCDNEnabled()) {
    return getMealRatingSummary({ mealID })
  }

  try {
    return await getMealRatingSummaryFromCDN({ mealID })
  } catch (error) {
    if (isNotEnoughRatingsError(error)) {
      throw error
    }

    return getMealRatingSummary({ mealID })
  }
}

// The API answers 404 when the meal has too few recent ratings to summarize.
function isNotEnoughRatingsError(error: unknown) {
  return (
    error instanceof Error && isResponseStatusCode({ error, statusCode: 404 })
  )
}

export const mealRatingSummaryQueries = {
  detail: ({ mealID }: { mealID: number }) =>
    queryOptions({
      queryKey: ['mealRatingSummary', mealID],
      queryFn: async () => {
        try {
          const { ratingSummary } = await getMealRatingSummaryPreferringCDN({
            mealID,
          })

          return ratingSummary
        } catch (error) {
          if (isNotEnoughRatingsError(error)) {
            return null
          }

          throw error
        }
      },
    }),
}
